import {Moment, unitOfTime} from 'moment';

import {ESameDateUnits} from 'shared/constants/watchers';

export const checkSameDateUnitConstraints = (
    current: Moment,
    target: Moment,
    isStart: boolean,
    unit?: string,
): boolean => {
    if (isStart ? current.isAfter(target) : current.isBefore(target)) return true;

    switch (unit) {
    case ESameDateUnits.sameDay:
        return target.day() !== current.day() || target.month() !== current.month() || target.year() !== current.year();
    case ESameDateUnits.sameMonth:
        return target.month() !== current.month() || target.year() !== current.year();
    case ESameDateUnits.sameYear:
        return target.year() !== current.year();
    default: return false;
    }
};

export const checkRangeConstraints = (
    current: Moment,
    target: Moment,
    isStart: boolean,
    unit?: string,
    amount?: number,
): boolean => {
    const rangeUnit = unit as unitOfTime.Diff || 'month';
    const rangeAmount = amount || 1;

    if (isStart) {
        return current.isAfter(target) || current.isBefore(target.clone().subtract(rangeAmount, rangeUnit));
    }
    return current.isAfter(target.clone().add(rangeAmount, rangeUnit)) || current.isBefore(target);
};
